import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from 'theme/tokens';

const StatusPill = ({ status, label, size = 'medium' }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const statusStyles = {};

  ['OPEN', 'NEW'].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.blue[100],
      textColor: colors.info.dark,
    };
  });

  ['PROGRESS', 'COVERED', 'TRANSIT', 'INVOICED'].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.main_blue[200],
      textColor: colors.info.dark,
    };
  });
  ['CHECK_IN', 'CHECK_OUT', 'LOADING', 'UNLOADING'].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.yellow[200],
      textColor: colors.base.black,
    };
  });
  ['TERMINAL', 'DELIVERED', 'LOADED', 'UNLOADED', 'COMPLETE', 'COMPLETED', 'RECEIVED', 'PAID', 'YES', 'ACTIVE'].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.green[200],
      textColor: colors.success.dark,
    };
  });
  ['YARD', 'YARD_IN', 'YARD_PULL', 'UNPAID', 'NO', 'EXPIRED'].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.red[200],
      textColor: colors.error.dark,
    };
  }); 
  ['DEFAULT',].forEach(status => {
    statusStyles[status] = {
      bgColor: colors.secondary.soft,
      textColor: colors.secondary.main,
    };    
  });  

  const height = size === 'small' ? 20 : 28;
  const width = size === 'small' ? 80 : 'inherit';
  const paddingX = size === 'small' ? 1 : 1.5;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1,
        width: width,
        height: height,
        borderRadius: '4px',
        backgroundColor: statusStyles[status] ? statusStyles[status].bgColor: colors.neutral[200],
        color: statusStyles[status] ? statusStyles[status].textColor: colors.neutral[800],
        fontWeight: 600,
        fontSize: size === 'small' ? '0.75rem' : '0.875rem',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
      }}
    >      
      <Typography variant={`${size === 'small' ? 'caption' : 'body1'}`} sx={{margin: 0, padding: 0}}>
        {label || status && status.replace(/_/g, ' ')}
      </Typography>
    </Box>
  );
};

export default StatusPill;
